<material-navbar [menuPosition]="settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')">
</material-navbar>

<section class="help-section">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <h1 class="title">How to Sign In on JioSh</h1>
                <p>Explore our PDF help document on how to sign in on JioSh or watch the YouTube video for step-by-step guidance.</p>
                <a 
                    href="/storage/help/sign-in.pdf"
                    mat-raised-button
                    class="primary-button"
                    color="accent"
                    target="_blank"
                    trans
                >
                    <mat-icon svgIcon="info"></mat-icon>
                    View PDF
                </a>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="card">
                    <div class="video-wrapper">
                        <iframe src="https://www.youtube.com/embed/yCqI9_Wr0MU?si=NMoPu1KNPo9jeXSD" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        >
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer class="footer"></app-footer>